/* sections-interactive-map.js */

document.querySelectorAll('[data-map-section]').forEach((root) => {
  const productsScript = root.querySelector('[data-map-products]');
  const mapContainer = root.querySelector('[data-map-container]');

  if (!productsScript || !mapContainer || typeof mapboxgl === 'undefined') return;

  let products = [];

  try {
    products = JSON.parse(productsScript.textContent || '[]');
  } catch (error) {
    console.error('Map products JSON error:', error);
    return;
  }

  if (!products.length) return;

  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => Array.from(root.querySelectorAll(selector));

  function decodeHtmlEntities(input) {
    const element = document.createElement('div');
    element.innerHTML = input || '';
    return element.textContent || element.innerText || '';
  }

  function toArray(value) {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value
        .flat()
        .map((item) => decodeHtmlEntities(String(item)).trim())
        .filter(Boolean);
    }

    return decodeHtmlEntities(String(value))
      .replace(/^\[/, '')
      .replace(/\]$/, '')
      .replace(/"/g, '')
      .replace(/&quot;/g, '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  products = products.map((product) => ({
    ...product,
    description: decodeHtmlEntities(product.description || ''),
    tourTypeArray: toArray(product.tourType),
    tourLocationArray: toArray(product.tourLocation),
    tourLengthArray: toArray(product.tourLength),
    tourStyleArray: toArray(product.tourStyle),
  }));

  mapboxgl.accessToken =
    'pk.eyJ1IjoidW5pcXVlLXVrIiwiYSI6ImNtN21tZ201NzBucngya3B3aTA5ZXc4NGQifQ.l8qmCmBM1_B4iObZ0RNXLA';

  const map = new mapboxgl.Map({
    container: mapContainer.id,
    style: 'mapbox://styles/unique-uk/cm7wvvu3j006y01st1fzb6ulj',
    center: [-1.9763, 51.7652],
    zoom: 7,
    projection: 'mercator',
  });

  let markers = [];

  const searchInput = $('[data-filter-input]');

  const geocodeCacheKey = `tour_geocode_cache_${mapContainer.id}`;

  const geocodeCache = (() => {
    try {
      return JSON.parse(localStorage.getItem(geocodeCacheKey) || '{}');
    } catch {
      return {};
    }
  })();

  function saveGeocodeCache() {
    try {
      localStorage.setItem(geocodeCacheKey, JSON.stringify(geocodeCache));
    } catch {}
  }

  async function geocodeAddress(address) {
    if (!address) return null;

    const cacheKey = address.trim().toLowerCase();

    if (geocodeCache[cacheKey]) return geocodeCache[cacheKey];

    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
      address
    )}.json?limit=1&access_token=${mapboxgl.accessToken}`;

    const res = await fetch(url);
    const data = await res.json();
    const coords = data?.features?.[0]?.geometry?.coordinates || null;

    if (coords) {
      geocodeCache[cacheKey] = coords;
      saveGeocodeCache();
    }

    return coords;
  }

  async function ensureCoords(items) {
    await Promise.all(
      items.map(async (product) => {
        if (Array.isArray(product._coords)) return;
        product._coords = await geocodeAddress(product.address);
      })
    );
  }

  function clearMarkers() {
    markers.forEach((marker) => marker.remove());
    markers = [];
  }

  async function renderMarkers(items) {
    clearMarkers();

    await ensureCoords(items);

    items.forEach((product) => {
      if (!product._coords) return;

      const marker = new mapboxgl.Marker({
        color: '#37424E',
        scale: 0.75,
      })
        .setLngLat(product._coords)
        .addTo(map);

      const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
        `<p class="hover-popup" style="text-align:center">${product.title}</p>`
      );

      const markerElement = marker.getElement();

      if (window.innerWidth >= 768) {
        markerElement.addEventListener('mouseenter', () => {
          popup.setLngLat(product._coords).addTo(map);
        });

        markerElement.addEventListener('mouseleave', () => {
          popup.remove();
        });
      }

      markerElement.addEventListener('click', () => {
        openProductModal(product);
      });

      markers.push(marker);
    });
  }

  function selectedValues(containerSelector) {
    return $$(`${containerSelector} input:checked`).map((input) => input.value);
  }

  function productMatchesSelected(productArray, selectedArray) {
    return (
      selectedArray.length === 0 ||
      selectedArray.some((value) => productArray.includes(value))
    );
  }

  async function filterProducts() {
    const searchQuery = (searchInput?.value || '').trim().toLowerCase();

    const selectedTypes = selectedValues('#tour-type-filters');
    const selectedLocations = selectedValues('#tour-location-filters');
    const selectedLengths = selectedValues('#tour-length-filters');
    const selectedStyles = selectedValues('#tour-style-filters');

    const filtered = products.filter((product) => {
      const searchMatch =
        !searchQuery ||
        product.title.toLowerCase().includes(searchQuery) ||
        product.address.toLowerCase().includes(searchQuery) ||
        product.tourLocationArray.some((location) =>
          location.toLowerCase().includes(searchQuery)
        );

      return (
        searchMatch &&
        productMatchesSelected(product.tourTypeArray, selectedTypes) &&
        productMatchesSelected(product.tourLocationArray, selectedLocations) &&
        productMatchesSelected(product.tourLengthArray, selectedLengths) &&
        productMatchesSelected(product.tourStyleArray, selectedStyles)
      );
    });

    await renderMarkers(filtered);
    updateResetButton();
    closePanel();
  }

  function populateFilters() {
    const filterGroups = [
      ['#tour-type-filters', 'tour-type', products.flatMap((p) => p.tourTypeArray)],
      ['#tour-location-filters', 'tour-location', products.flatMap((p) => p.tourLocationArray)],
      ['#tour-length-filters', 'tour-length', products.flatMap((p) => p.tourLengthArray)],
      ['#tour-style-filters', 'tour-style', products.flatMap((p) => p.tourStyleArray)],
    ];

    filterGroups.forEach(([containerSelector, prefix, values]) => {
      const container = $(containerSelector);
      if (!container) return;

      container.innerHTML = '';

      [...new Set(values)]
        .filter(Boolean)
        .sort()
        .forEach((value, index) => {
          const id = `${mapContainer.id}-${prefix}-${index}`;

          const label = document.createElement('label');
          label.setAttribute('for', id);
          label.textContent = value;

          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.id = id;
          checkbox.value = value;

          label.appendChild(checkbox);
          container.appendChild(label);
        });
    });
  }

  function updateResetButton() {
    const hasCheckedFilters =
      $$(
        '#tour-type-filters input:checked, #tour-location-filters input:checked, #tour-length-filters input:checked, #tour-style-filters input:checked'
      ).length > 0;

    const hasSearch = !!searchInput?.value.trim();
    const resetButton = $('#reset-filters-btn');

    resetButton?.classList.toggle('hidden', !hasCheckedFilters && !hasSearch);
  }

  function openPanel() {
    $('#filter-details-view')?.classList.add('show');
    $('#filter-side-panel')?.classList.add('panel-open');
    $('.filter-side-action-bar')?.classList.add('show');
    $('.filter-side-nav')?.classList.add('open');
    $('.search-button')?.classList.add('selected');
  }

  function closePanel() {
    $$('.filter-side-details-view').forEach((view) => view.classList.remove('show'));
    $('#filter-side-panel')?.classList.remove('panel-open');
    $('.filter-side-action-bar')?.classList.remove('show');
    $('.filter-side-nav')?.classList.remove('open');
    $$('.filter-nav-button').forEach((button) => button.classList.remove('selected'));
  }

  async function resetFilters() {
    $$(
      '#tour-type-filters input, #tour-location-filters input, #tour-length-filters input, #tour-style-filters input'
    ).forEach((input) => {
      input.checked = false;
    });

    if (searchInput) searchInput.value = '';

    await renderMarkers(products);
    updateResetButton();
  }

  function openProductModal(product) {
    const wrapper = $('#product-info-modal-wrapper');
    const container = $('#product-info-modal__container');

    if (!wrapper || !container) return;

    fetch(`/products/${product.handle}?view=product-info-api`)
      .then((res) => res.text())
      .then((html) => {
        const tempDoc = new DOMParser().parseFromString(html, 'text/html');
        const content = tempDoc.querySelector('#product-info-modal__content');

        if (!content) return;

        container.querySelector('#product-info-modal__content')?.remove();
        container.appendChild(content);

        wrapper.classList.remove('hide');
        document.body.classList.add('no-scroll');

content.querySelector('[add-to-cart]')?.addEventListener('click', async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const button = event.currentTarget;
  const variantId = button.dataset.variantId;

  if (!variantId || button.disabled) return;

  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error('Unable to add item');
    }

    button.textContent = 'Added';
    button.classList.add('added');

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
      })
    );
  } catch (error) {
    console.error('Wishlist error:', error);

    button.textContent = 'Add to Wishlist';
    button.disabled = false;
  }
});
      })
      .catch(console.error);
  }

  $('#product-info-modal__close')?.addEventListener('click', () => {
    $('#product-info-modal-wrapper')?.classList.add('hide');
    document.body.classList.remove('no-scroll');
  });

  $('#product-info-modal-wrapper')?.addEventListener('click', (event) => {
    if (event.target === $('#product-info-modal-wrapper')) {
      $('#product-info-modal-wrapper')?.classList.add('hide');
      document.body.classList.remove('no-scroll');
    }
  });

  $('.filter-side-nav')?.addEventListener('click', () => {
    const isOpen = $('.filter-side-nav')?.classList.contains('open');
    isOpen ? closePanel() : openPanel();
  });

  $('.overlay')?.addEventListener('click', closePanel);
  $('#filter-side-details-close-button')?.addEventListener('click', closePanel);

  $$('.filter-nav-button[data-detail-view]').forEach((button) => {
    button.addEventListener('click', openPanel);
  });

  $$('[apply-filters-btn]').forEach((button) => {
    button.addEventListener('click', () => filterProducts().catch(console.error));
  });

  $('#reset-filters-btn')?.addEventListener('click', () => {
    resetFilters().catch(console.error);
  });

  searchInput?.addEventListener('input', updateResetButton);

  $$(
    '#tour-type-filters, #tour-location-filters, #tour-length-filters, #tour-style-filters'
  ).forEach((container) => {
    container.addEventListener('change', updateResetButton);
  });

  map.on('load', async () => {
    populateFilters();
    await renderMarkers(products);
    updateResetButton();
  });
});